import classNames from 'classnames';
import { Button } from '../../../ui';
import Link from 'next/link';

const Timeline = () => {
  return (
    <div className="bg-[#272727] ">
      <div className="container flex flex-col items-center gap-[32px] py-[48px] relative z-20">
        <div className="flex flex-col items-center gap-[18px]">
          <h2 className="text-center font-[500] text-[32px] md:text-[48px] leading-[39px] md:leading-[59px] text-white">Campaign timeline</h2>
          <div className="md:text-[18px] text-[14px] leading-[22px] text-white text-center max-w-[518px]">From booking to final whistle.</div>
        </div>
        <div className="hide_scrollbar flex flex-row flex-nowrap items-center justify-between w-full gap-[20px] overflow-x-auto">
          <div className="flex flex-col flex-none gap-[16px] w-[180px]">
            <p className="text-[24px] text-[#D5DD23] leading-[30px]">Now → May 31.</p>
            <span className="text-[14px] text-white leading-[20px]">Booking window. Lock in placements and creative assets..</span>
          </div>
          <div className="flex flex-col flex-none gap-[16px] w-[180px]">
            <p className="text-[24px] text-[#D5DD23] leading-[30px]">June 11</p>
            <span className="text-[14px] text-white leading-[20px]">Tournament opens. All campaigns go live simultaneously.</span>
          </div>
          <div className="flex flex-col flex-none gap-[16px] w-[180px]">
            <p className="text-[24px] text-[#D5DD23] leading-[30px]">June 11–30</p>
            <span className="text-[14px] text-white leading-[20px]">Group stage. Peak volume window. Maximum reach.</span>
          </div>
          <div className="flex flex-col flex-none gap-[16px] w-[180px]">
            <p className="text-[24px] text-[#D5DD23] leading-[30px]">July 1–18</p>
            <span className="text-[14px] text-white leading-[20px]">Knockouts & semifinals. Highest audience engagement..</span>
          </div>
          <div className="flex flex-col flex-none gap-[16px] w-[180px]">
            <p className="text-[24px] text-[#D5DD23] leading-[30px]">July 19</p>
            <span className="text-[14px] text-white leading-[20px]">World Cup Final. Post-campaign wrap & full report.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
